<template>
	<div class="detail-form">
		<div class="row" v-show="!isLoadingDocTypes">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="name">Nome do Tipo de Documento: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.name ? 'alert' : '']"
					id="name"
					type="text"
					placeholder="Nome do Tipo de Documento"
					v-model="docType.name"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.name">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="status">Idioma:</label>
				<input
					class="detail-form__field--input disabled"
					id="name"
					type="text"
					placeholder="PT-BR"
					value="PT-BR"
				/>
			</div>
		</div>
		<div class="row" v-show="!isLoadingDocTypes">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="secondName">Nome do Tipo de Documento: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.secondName ? 'alert' : '']"
					id="secondName"
					type="text"
					placeholder="Nome do Tipo de Documento"
					v-model="docType.secondName"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.secondName">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="status">Idioma:</label>
				<input
					class="detail-form__field--input disabled"
					id="name"
					type="text"
					placeholder="EN-US"
					value="EN-US"
				/>
			</div>
		</div>
		<div
			class="detail-form__actions"
			:class="newDocType ? 'new-docType' : ''"
			v-show="!isLoadingDocTypes"
		>
			<button
				class="detail-form__actions--btn outline"
				@click="handleDeleteModal()"
				v-if="!newDocType"
			>
				Excluir Tipo de Documento
			</button>
			<button class="detail-form__actions--btn" @click="validateFields()">Salvar</button>
		</div>
		<div class="row justify-center align-center w-90-vw h-70-vh" v-if="isLoadingDocTypes">
			<SpinnerIcon />
		</div>
		<DeleteModal
			:title="'Excluir Tipo de Documento'"
			:subtitle="'Tem certeza que deseja excluir este Tipo de Documento?'"
			:loader="isLoadingDocTypes"
			v-show="showDeleteModal"
			@handleDeleteModal="handleDeleteModal()"
			@confirmDelete="confirmDelete()"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
	GET_DOC_TYPE_BY_ID,
	CREATE_DOC_TYPE,
	UPDATE_DOC_TYPE,
	DELETE_DOC_TYPE,
} from '@/store/modules/docTypeManagement/actions';
import { mask } from 'vue-the-mask';
import GenericMultiselect from '@/components/shared/GenericMultiselect/GenericMultiselect.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import DeleteModal from '@/components/shared/DeleteModal/DeleteModal.vue';

export default {
	name: 'DocTypeForm',
	directives: { mask },
	components: { GenericMultiselect, SpinnerIcon, DeleteModal },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		docType: {
			name: '',
			secondName: '',
		},
		requiredFields: {
			name: false,
			secondName: false,
		},
		newDocType: false,
		isEditing: false,
		showDeleteModal: false,
	}),
	created() {},
	mounted() {
		if (this.$route.query.id) {
			this.getDocType({ vm: this, id: this.$route.query.id }).then((res) => {
				const selectedDocType = res.data;

				selectedDocType.forEach((item) => {
					if (item.language == 'pt-br') this.docType.name = item.name;
					if (item.language == 'en-us') this.docType.secondName = item.name;
				});
			});
		} else {
			this.newDocType = true;
		}
	},
	methods: {
		...mapActions('docTypeManagement', {
			getDocType: GET_DOC_TYPE_BY_ID,
			createNewDocType: CREATE_DOC_TYPE,
			updateDocType: UPDATE_DOC_TYPE,
			deleteDocType: DELETE_DOC_TYPE,
		}),
		handleDeleteModal() {
			this.showDeleteModal = !this.showDeleteModal;
		},
		confirmDelete() {
			this.deleteDocType({ vm: this, id: this.$route.query.id })
				.then((res) => {
					this.handleDeleteModal();
					if (res.status == 200) {
						this.$router.push({ path: '/dashboard/config/docType' });
					}
				})
				.catch((e) => {
					this.handleDeleteModal();
				});
		},
		createDocType() {
			const body = { itens: [] };

			body.itens.push(
				{ name: this.docType.name, language: 'pt-br' },
				{ name: this.docType.secondName, language: 'en-us' },
			);

			this.createNewDocType({ vm: this, body: body }).then((res) => {
				if (res.status == 201) {
					this.$router.push({ path: '/dashboard/config/docType' });
				}
			});
		},
		confirmUpdate() {
			const body = { itens: [] };

			body.itens.push(
				{ name: this.docType.name, language: 'pt-br' },
				{ name: this.docType.secondName, language: 'en-us' },
			);

			this.updateDocType({ vm: this, id: this.$route.query.id, body: body }).then((res) => {
				if (res.status == 200) {
					this.isEditing = false;
				}
			});
		},
		validateFields() {
			this.requiredFields = {
				name: true,
				secondName: true,
			};

			if (this.docType.name) this.requiredFields.name = false;
			if (this.docType.secondName) this.requiredFields.secondName = false;

			if (!this.docType.name || !this.docType.secondName) {
				return;
			}

			if (!this.newDocType) {
				this.confirmUpdate();
			} else {
				this.createDocType();
			}
		},
	},
	computed: {
		...mapGetters('docTypeManagement', ['isLoadingDocTypes']),
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'DocTypeForm.scss';
</style>
